<div class="wrapper">
    <div class="name-and-format-row">
        <span class="editable-field-row">
            <b class="title-font" [style.cursor]="'pointer'" *ngIf="!fullEditMode && !editName" (click)="editName = true">{{deck?.name}}</b>
            <mat-form-field color="primary" appearance="fill" *ngIf="fullEditMode || editName" [style.margin-right]="'10px'">
                <mat-hint>Deck Name</mat-hint>
                <input matInput [value]="deck.name" [formControl]="deckNameCtrl"/>
            </mat-form-field>
            <button *ngIf="editName" mat-icon-button (click)="saveName()"><mat-icon>save</mat-icon></button>
            <button *ngIf="editName" mat-icon-button (click)="cancel(); editName = false"><mat-icon>cancel</mat-icon></button>
        </span>
        <b class="title-font">&nbsp;--&nbsp;</b>
        <span class="editable-field-row">
            <b class="title-font" [style.cursor]="'pointer'" *ngIf="!fullEditMode && !editFormat" (click)="editFormat = true">{{deck?.format}}</b>
            <mat-form-field color="warn" appearance="fill" *ngIf="fullEditMode || editFormat" [style.margin-right]="'10px'">
                <mat-hint>Format</mat-hint>
                <mat-select [formControl]="deckFormatCtrl">
                    <mat-option *ngFor="let format of formats" [value]="format">{{format}}</mat-option>
                </mat-select>
                <mat-error>WARNING: You may lose data by changing the format!</mat-error>
            </mat-form-field>
            <button *ngIf="editFormat" mat-icon-button (click)="saveFormat()"><mat-icon>save</mat-icon></button>
            <button *ngIf="editFormat" mat-icon-button (click)="cancel(); editFormat = false;"><mat-icon>cancel</mat-icon></button>
        </span>
        <b class="title-font deck-size">&nbsp;({{deck?.totalQuantity}} Cards)</b>
        <mat-form-field color="warn" appearance="fill" *ngIf="fullEditMode && deck?.format === 'Block'">
            <mat-hint>Block</mat-hint>
            <mat-select [formControl]="blockCtrl">
                <mat-option *ngFor="let block of blocks" [value]="block.block">{{block.block}}</mat-option>
            </mat-select>
            <mat-error>WARNING: You may lose data by changing the block!</mat-error>
        </mat-form-field>
        <div class="sharing-checkboxes" *ngIf="fullEditMode">
            <mat-checkbox [formControl]="isPublicCtrl">Publish on DeckPlan</mat-checkbox>
            <mat-checkbox [formControl]="isLinkShareableCtrl">Share With Link (only published if Publish also checked)</mat-checkbox>
        </div>
        <button mat-icon-button *ngIf="!fullEditMode" [color]="likeButtonColor" (click)="toggleLikeDeck()" matTooltip="Likes" gtagEvent trackOn="click" action="upvote_Deck" category="decks">
            <mat-icon [innerHTML]="likeIconName"></mat-icon> {{deck?.upvoteCount}}
        </button>
        <span class="spacer"></span>
        <div class="import-button">
            <button mat-mini-fab color="accent" matTooltip="Import/Export" [matMenuTriggerFor]="importMenu"><mat-icon>import_export</mat-icon></button>
            <mat-menu #importMenu="matMenu">
                <button mat-menu-item (click)="showManualImport()">
                    <mat-icon>dynamic_form</mat-icon>
                    Manual
                </button>
                <button mat-menu-item (click)="showFileImport()">
                    <mat-icon>text_snippet</mat-icon>
                    File
                </button>
                <button mat-menu-item [matMenuTriggerFor]="exportMenu">
                    Export
                </button>
                <mat-menu #exportMenu="matMenu">
                    <button mat-menu-item (click)="doExport()">
                        <mat-icon>content_copy</mat-icon>
                        Copy
                    </button>
                    <button mat-menu-item (click)="doExport(true)">
                        <mat-icon>save</mat-icon>
                        Save
                    </button>
                </mat-menu>
            </mat-menu>
        </div>
        <button mat-mini-fab color="warn" *ngIf="fullEditMode" (click)="cancel()" matTooltip="Cancel"
                [style.margin-right]="'10px'" gtagEvent trackOn="click" action="cancel_edit" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">
            <mat-icon>cancel</mat-icon>
        </button>
        <button mat-mini-fab *ngIf="!fullEditMode && (deck?.isPublic || deck?.isLinkShareable)" (click)="copyShareLink()" matTooltip="Copy share link" [style.margin-right]="'10px'" gtagEvent trackOn="click" action="share_deck" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">
            <mat-icon>share</mat-icon>
        </button>
        <button mat-mini-fab *ngIf="!fullEditMode" (click)="fullEditMode = true; editName = false; editFormat = false; editFocus = false" matTooltip="Edit" gtagEvent trackOn="click" action="edit_deck_on" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-mini-fab *ngIf="fullEditMode" (click)="save()" matTooltip="Save" gtagEvent trackOn="click" action="save_deck_clicked" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">
            <mat-icon>save</mat-icon>
        </button>
    </div>
    <div *ngIf="deck?.format === 'Two Headed Giant'">Note! Not enforcing rules for this format!</div>
    <div class="focus-row">
        <div class="focused-card" [ngClass]="{'edit-mode': editFocus}">
            <app-card-image (cardClicked)="editFocus = true" *ngIf="!fullEditMode && !editFocus" [card]="focusedCard | async" [width]="225" [clickable]="true" [hoverable]="false" [draggable]="false"></app-card-image>
            <div class="edit-focus-button-row">
                <button *ngIf="editFocus" mat-icon-button (click)="saveFocus();"><mat-icon>save</mat-icon></button>
                <button *ngIf="editFocus" mat-icon-button (click)="cancel(); editFocus = false;"><mat-icon>cancel</mat-icon></button>
            </div>
            <div class="select-focus-overlay" *ngIf="fullEditMode || editFocus"
                 [style.background-image]="'url(' + (focusedCard | async)?.images.normal + ')'">
                <div class="prompt" matRipple (click)="selectFocused()">{{format?.selectFocusText()}}</div>
            </div>
        </div>
        <div class="cmc-histo">
            <app-histogram [data]="cmcHisto | async" title="CMC Histogram" xAxesLabel="cmc" yAxesLabel="Count"
                           barPercentage="1.25"></app-histogram>
        </div>
<!-- TODO: We need a better visualization for mana balance. The Radar diagram is only useful for niche decks -->
<!--       like 4 or 5 color commanders. Leaving this hear for a reminder that this needs handled -->
<!--        <div class="mana-balance">-->
<!--            <app-radar [data]="manaBalance | async" title="Mana Balance"-->
<!--                       [labels]="['Red', 'Blue', 'Black', 'Green', 'White', 'Colorless']"></app-radar>-->
<!--        </div>-->
        <div class="type-compositions">
            <app-histogram [data]="typeCompositions | async" title="Type Composition" xAxesLabel="Type"
                           yAxesLabel="Count"></app-histogram>
        </div>
        <div class="color-stats">
            <app-pie-chart title="Color Composition"
                           [sectionColors]="['#f2eeca', '#aae1fa', '#cac0be', '#f5a78d', '#96cda9', '#c7d4f2']"
                           [sectionLabels]="['White', 'Blue', 'Black', 'Red', 'Green', 'Colorless']"
                           [data]="colorStats | async"></app-pie-chart>
        </div>
    </div>
    <mat-slide-toggle class="summary-toggle" [(ngModel)]="showSummary" gtagEvent trackOn="click" action="toggle_summary" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">Summary View</mat-slide-toggle>
    <div class="deck-and-cards-row" *ngIf="deck">
        <div class="deck-and-summary" cdkDropList [cdkDropListSortingDisabled]="true" id="user-deck"
             (cdkDropListDropped)="onCardDrop($event)">
            <div *ngIf="showSummary" class="deck-summary">
                <app-deck-summary [deck]="deck" [format]="format" [style.width]="'100%'" (cardActionTaken)="forceUpdate()"></app-deck-summary>
            </div>
            <div *ngIf="!showSummary" class="deck">
                <app-card-table [cards]="deck?.cards" tableId="deck-table" [columns]="columns" [totalSize]="deck?.filteredCardCount"
                                (newQuery)="queryUpdated.next($event)" (pagingChanged)="pageUpdated.next($event)"
                                (cardContextClicked)="contextMenu.openCardContext($event)" [isValid]="cardValidator"
                                (cardActionTaken)="forceUpdate()"
                                (cardInputFieldChanged)="onCardInputChanged($event)"
                                [style.width]="'100%'" [removableCards]="{deckId: this.deck?.id}" [addCardsToInventory]="true" [addCardsToDeck]="false"></app-card-table>
                <app-context-menu #contextMenu (clicked)="removeCard($event)" icon="delete"
                                  label="Remove Card"></app-context-menu>
            </div>
        </div>
        <div class="search">
            <app-card-search #cardSearch tableId="deck-card-search" (cardClicked)="addCard($event)" [showDragHint]="true" [setQuery]="addQuery" [columns]="searchColumns"
                             [style.width]="'100%'" [showOwnedCardsSelector]="true" [removableCards]="false" [addCardsToInventory]="false"
                             [addCardsToDeck]="{ deckId: this.deck?.id }" (cardActionTaken)="forceUpdate()"></app-card-search>
            <mat-checkbox [formControl]="searchRulesCtrl">Disable format rules in search</mat-checkbox>
        </div>
    </div>
    <mat-error *ngIf="invalidCards.size">Invalid cards for the format are marked with red ({{invalidCards.size}} unique card names are invalid)</mat-error>
</div>
